import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {

  getTarifas: () => {
    return axios.get(`${deployPath}/api/yates/tarifas`)
      .then(tarifas => {
        return tarifas.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
  
  getMotores: () => {
    return axios.get(`${deployPath}/api/yates/motores`)
      .then(motores => {
        return motores.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getMateriales: () => {
    return axios.get(`${deployPath}/api/yates/materiales`)
      .then(materiales => {
        return materiales.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getTiposBarco: () => {
    return axios.get(`${deployPath}/api/yates/tiposBarco`)
      .then(tiposBarco => {
        return tiposBarco.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getBanderas: () => {
    return axios.get(`${deployPath}/api/yates/banderas`)
      .then(banderas => {
        return banderas.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
  
    
  getPlanPagos: () => {
    return axios.get(`${deployPath}/api/yates/planPagos`)
      .then(planPagos => {
        return planPagos.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getZonasResidencia: () => {
    return axios.get(`${deployPath}/api/yates/zonasResidencia`)
      .then(zonasResidencia => {
        return zonasResidencia.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getMarinas: (codigoZona) => {
    return axios.get(`${deployPath}/api/yates/marinas/${codigoZona}`)
      .then(marinas => {
        return marinas.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getQuotation: (request) => {
    return axios.post(`${deployPath}/api/yates/quotation/`, request)
      .then(quotation => {
        return quotation.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
};
